import React, { useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaDownload } from "react-icons/fa6";

const AddBranchLead = () => {
  const [statuses, setStatuses] = useState(['']);

  const handleAddStatus = () => {
    setStatuses([...statuses, '']);
  };

  const handleStatusChange = (index, value) => {
    const updatedStatuses = [...statuses];
    updatedStatuses[index] = value;
    setStatuses(updatedStatuses);
  };

 const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="container py-4">
      {/* Add Country Section */}
     <div className='d-flex align-items-center justify-content-center'>
         <div className="fs-2 px-3 py-2 mb-2 text-center bg-dark text-white">
          Lead Information
        </div>
     </div>
      <div className="card mb-4 shadow-sm">
        
        <div className="card-body row">
            <div className="mb-3 col-md-6 col-12">
            <label>Source of lead</label>
            <select className="form-control" >
                <option>Front Office</option>
            </select>
          </div>
          <div className="mb-3 col-md-6 col-12">
            <label>Student First Name</label>
            <input type="text" className="form-control" />
          </div>
           <div className="mb-3 col-md-6 col-12">
            <label>Student Last Name</label>
            <input type="text" className="form-control" />
          </div>
           <div className="mb-3 col-md-6 col-12">
            <label>Country of Interest</label>
            <input type="text" className="form-control" />
          </div>
             <div className="mb-3 col-md-6 col-12">
            <label>Interested Institution</label>
            <input type="text" className="form-control" />
          </div>
          <div className="mb-3 col-md-6 col-12">
            <label>E-mail</label>
            <input type="email" className="form-control" />
          </div>
            <div className="mb-3 col-md-6 col-12">
            <label>Date of Birth</label>
            <input type="date" className="form-control" />
          </div>
          <div className="mb-3 col-md-6 col-12">
            <label>Phone No</label>
            <input type="text" className="form-control" />
          </div>
          <div className="mb-3 col-md-6 col-12">
            <label>Mobile</label>
            <input type="text" className="form-control" />
          </div>
           <div className="mb-3 col-md-6 col-12">
            <label>Skype ID</label>
            <input type="text" className="form-control" />
          </div>
          <div className="mb-3 col-md-6 col-12">
            <label>Estimated Budget</label>
            <input type="text" className="form-control" />
          </div>
            <div className="col-md-6 col-12 mb-3">
            <label>Course Level of Interest</label>
            <select className="form-control" >
                <option>Highly Interested</option>
                <option>Mild Interest</option>
                <option>Low Interest</option>
                 <option>Other</option>
            </select>
          </div>
          
{/* Field Level of Interest */}
     <div className="accordion mt-4" id="workexpereince">
  <div className="accordion-item">
    <h2 className="accordion-header ">
      <button className="accordion-button bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWork" aria-expanded="true" aria-controls="collapseWork">
       Field Level of Interest
      </button>
    </h2>
    <div id="collapseWork" className="accordion-collapse collapse show" data-bs-parent="#workexpereince">
      <div className="accordion-body">
        <div className='row'>
            <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Art & Design</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Business & management</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Humanities</span>
                </div>
            </div>
        </div>
         <div className='row'>
            <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Commerce</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Sports</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Education & Training</span>
                </div>
            </div>
        </div>
        <div className='row'>
            <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Health Science</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Nursing</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Engineering</span>
                </div>
            </div>
        </div>
         <div className='row'>
            <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Law</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Accounting & Marketing</span>
                </div>
            </div>
             <div className='col-md-4 col-12'>
                <div className='d-flex'>
                    <input type='checkbox' /><span className='mx-2'> Travel</span>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>


         
        </div>
      </div>




    {/* Additional Information */}
<div className='d-flex align-items-center mt-3 justify-content-center'>
         <div className="fs-2 px-4 py-2 mb-2 text-center bg-dark text-white">
          Additional Information
        </div>
     </div>

  <div className="card shadow-sm">
        <div className="card-body row">
         <div className="mb-3 col-md-6 col-12">
            <label>Academic Qualification</label>
            <input type='text' className='form-control' />
          </div>
  <div className="mb-3 col-md-6 col-12">
            <label>English Evidence ( IELTS/TOEFL )</label>
            <input type='text' className='form-control' />
          </div>
           <div className="mb-3 col-md-6 col-12">
            <label>12th/Bachelor’s Score</label>
            <input type='text' className='form-control' />
          </div>
  <div className="mb-3 col-md-6 col-12">
            <label>Whatsapp No</label>
            <input type='text' className='form-control' />
          </div>
          <div className="mb-3 col-md-6 col-12">
            <label>Bank Statement</label>
            <input type='text' className='form-control' />
          </div>


        

        </div>
      </div>




<div className='d-flex align-items-center mt-3 justify-content-center'>
         <div className="fs-2 px-4 py-2 mb-2 text-center bg-dark text-white">
         Follow Up Details
        </div>
     </div>

  <div className="card shadow-sm">
        <div className="card-body row">
          <div className="col-md-6 col-12 mb-3">
            <label>Lead Type</label>
            <input type="text" className="form-control" />
            </div>
            <div className="col-md-6 col-12 mb-3">
            <label>Follow Up Date</label>
            <input type="text" className="form-control" />
            </div>
            <div className="col-md-6 col-12 mb-3">
            <label>Time</label>
            <input type="time" className="form-control" />
            </div>
            <div className="col-md-6 col-12 mb-3">
            <label>Follow Up Mode</label>
            <input type="text" className="form-control" />
            </div>
 <div className="col-md-6 col-12 mb-3">
            <label>Remarks</label>
            <input type="text" className="form-control" />
            </div>

          


        

          <div className="d-flex gap-2 pt-3 pb-3">
  <button type="submit" className="btn btn-primary">Submit</button>
</div>

          <div className="mt-3">
            <Link to={'/branch-office/lead-management/view'} type="button" className="btn bg-light buttonadd"><IoArrowUndoSharp size={20} /> Back</Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AddBranchLead;
